import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import { VStack, Box } from '@chakra-ui/layout';
import Header from './components/pages/Header';
import Footer from './components/pages/Footer';
import BackToTop from './components/BackToTop';
import PageTransition from './components/ui/PageTransition';

function App() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change
  
  return (
    <>
    {/* <DndProvider backend={HTML5Backend}> */}
        <Header id='navbar'/>
        <Box id='detail'>
          <VStack>
            <PageTransition type="slide">
              <Outlet />
            </PageTransition>
          </VStack>
        </Box>
        <Footer />
        <BackToTop />
      {/* </DndProvider> */}
    </>
  );
}

export default App;
